import React, { useRef, useEffect, useContext } from 'react';
import { useRouter } from 'next/router';
import { CoreContext } from './context/index.js';
import { logImgLoadErrorToRelic } from './utils/logToRelic.js';

const CarouselVerticalComponent = ({ items = [], thumbnailImage = '', title = '' }) => {
    const carouselRef = useRef(null);
    useEffect(() => {
        var _a, _b;
        const CAROUSEL_IMAGE_COUNT = 2; // using this constant to check if the carousel has changed
        if (items.length === CAROUSEL_IMAGE_COUNT && carouselRef.current) {
            // Sometimes the user has scrolled down the page and when they finish selecting the Product options,
            // this carousel will only display two images, leaving the user at the bottom of the page.
            // This will scroll the user back to the top of the page.
            const firstImageTop = (_a = carouselRef.current.firstElementChild) === null || _a === void 0 ? void 0 : _a.getBoundingClientRect().top;
            const firstImageBottom = (_b = carouselRef.current.firstElementChild) === null || _b === void 0 ? void 0 : _b.getBoundingClientRect().bottom;
            const isFirstImageBottomInView = firstImageBottom >= 0 && firstImageBottom <= window.innerHeight;
            const headerElement = document.querySelector('header');
            const headerHeight = headerElement ? headerElement.offsetHeight : 0; // get header's height
            const scrollPosition = firstImageTop + window.scrollY - headerHeight;
            if (isFirstImageBottomInView && window.scrollY > firstImageTop) {
                if (typeof window !== 'undefined') {
                    window.scrollTo({
                        top: scrollPosition,
                        left: 0,
                        behavior: 'smooth',
                    });
                }
            }
        }
        return () => { };
    }, [items]);
    const { asPath } = useRouter();
    const { data } = useContext(CoreContext);
    const { imageHeight, imageWidth, imageWidthThumbnail } = data.siteConfig.product;
    return (React.createElement("div", { ref: carouselRef, className: "base-image-carousel-vertical", "aria-roledescription": "carousel", role: "group" }, items.map((item, index) => (React.createElement("div", { className: "vertical-carousel-item", key: item.uuid },
        React.createElement("picture", null,
            index === 0 && (React.createElement("source", { srcSet: thumbnailImage, media: `(max-width: ${imageWidthThumbnail}px)` })),
            React.createElement("img", { src: item.url, className: "slider-image", alt: `${title} ${index + 1}`, width: imageWidth, height: imageHeight, onError: () => logImgLoadErrorToRelic(asPath, item.url), loading: index === 0 ? 'eager' : 'lazy' })))))));
};

export { CarouselVerticalComponent as C };
//# sourceMappingURL=ImagesCarouselVertical-bJyvVPoG.js.map
